import API_URLS from '../../constants/api-urls';
import axios from '../../utils/axios';

const store = {};

const authorsMaterials: Service = {
    // @ts-ignore
    get: (id: number) => {
        const query = `query {materials (filter: {author_id: ${id}}, order_by: {sort: id, order: ASC} pagination: {page: 1, limit: 200}) {
                id}}`;

        return new Promise((resolve, reject) => {
            if (store[id]) {
                return resolve(store[id]);
            }

            return axios
                .post(API_URLS.AUTHORS_MATERIAL_IDS, { query })
                .then((r) => {
                    store[id] = r.data.materials.map((material: Material) => material.id);

                    return resolve(store[id]);
                })
                .catch(reject);
        });
    }
};

export default authorsMaterials;
